export { SkillInteriorDesign as default } from './SkillInteriorDesign';
